<template>
  <div class="transfer-service container" id="transfer-service">
     <div class="spin-container" v-if="loading">
      <a-spin ></a-spin>
    </div>
    <div v-else class="transfer-service-content">
      <a-tabs type="card" v-model='activeTabKey' @tabClick="reset">
        <a-tab-pane v-for="(group, index) in listByFilter" :tab="group.title" :key="`${index + 1}`">
          <div class="flex-hr-vc">
            <a-input-search placeholder="请输入关键字" style="width: 200px; margin: 10px 0" v-model="searchValue"/>
          </div>
          <div>
            <a-collapse accordion defaultActiveKey="1" v-if="group.contents.length > 0">
              <a-collapse-panel v-for="(item, index) in group.contents" :header="item.title" :key="`${index + 1}`" :data-cms="item._id">
                <!-- NOTE: 支持两种模式，通过moduleId展示详情，或者通过pageId跳转展示详情 -->
                <div v-if="!item.isShowMore" v-html="item.content" ></div>
                <div v-else class="flex-hb-vc">
                  <div class="flex-hl-vc">
                    <h4>{{ item.title }}</h4>
                    <span class="content-time">{{ item.time | dateFilter('YYYY-MM-DD HH:mm:ss') }}</span>
                  </div>
                  <router-link :to="`/article/${item.pageId}`">
                    <a-button type="primary">阅读</a-button>
                  </router-link>
                </div>
              </a-collapse-panel>
            </a-collapse>
            <template v-else>
              <span>{{ !!searchValue.toString() ? '查无数据' : '暂无数据' }}</span>
            </template>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div v-if="notice" class="transfer-tip" :data-cms="notice._id">
        <div class="cell-header"><l8-icon type="icon-zhuyi"></l8-icon>温馨提醒</div>
        <div class="cell-body" v-html="notice"></div>
      </div>
    </div>
  </div>
</template>

<script>
import './index.less'
import './index'
import { get, sortBy } from 'lodash'
import moment from 'moment'
import { dateFilter } from '@/filters/util'

export default {
  data () {
    return {
      cmsContent: {},
      activeTabKey: '1',
      list: [],
      notice: null,
      searchValue: '',
      listByFilter: [],
      loading: true
    }
  },
  created () {
    this.cmsContent = window.__MICRO_ROOT__ ?? {}
    this.getTransferInfo()
  },
  methods: {
    reset () {
      this.searchValue = ''
    },
    async getTransferInfo () {
      const tabList = (await this.cmsContent.cms?.getPageData()) ?? {}
      const { list } = get(tabList, 'transfer-service-map')
      this.list = list
      this.getTransferContents()
    },
    async getTransferContents () {
      const { list, cmsContent, isBiddingPage } = this
      let contentIdList = []
      // 获取所有的id推入contentIdList
      for (const item of list) {
        for (const contentMsg of item.contents) {
          contentIdList.push(contentMsg.id)
        }
      }
      const contentResult = (await cmsContent.cms?.fetchItems(contentIdList)) ?? {}
      // 对应id去分配文案
      for (const item of list) {
        for (const contentMsg of item.contents) {
          if (!isBiddingPage) {
            contentMsg.isShowMore = false
            contentMsg.content = contentResult[contentMsg.id]?.content
          } else {
            contentMsg.isShowMore = true
            contentMsg.time = contentResult[contentMsg.id]?.time
          }
        }
        if (isBiddingPage) {
          item.contents = sortBy(item.contents, (item) => {
            return -moment(item.time).toDate().getTime()
          })
        }
      }
      this.listByFilter = list
      this.loading = false
    }
  },
  computed: {
    isBiddingPage () {
      const { list = [] } = this
      return !!list[0]?.contents?.[0]?.pageId
    }
  },
  watch: {
    searchValue: {
      handler (newV, oldV) {
        try {
          const { list, activeTabKey, searchValue } = this
          this.listByFilter = JSON.parse(JSON.stringify(list)) || []
          const filterItem = list[activeTabKey - 1].contents.filter((item) => { return item.title.indexOf(searchValue) >= 0 })
          this.listByFilter[activeTabKey - 1].contents = filterItem || []
          this.$set(this.listByFilter[activeTabKey - 1], 'contents', filterItem || [])
        } catch (error) {
          console.log('error >>>> ', error)
        }
      }
    }
  },
  filters: {
    dateFilter
  }
}
</script>
